<template>
  <div class="w-full h-16 border-b shadow p-5 bg-slate-50 sticky top-0 z-50 ">
    <div class="w-full h-full flex items-center">
      <div v-if="isShowBack">
        <button
          class="w-fit bg-transparent mr-4 text-xl"
          @click="back"
        >
          <i class="fa-solid fa-angle-left"></i>
        </button>
      </div>

      <div class="w-full flex items-center justify-between">
        <p @click="back" class="text-lg">
          {{ tableStore?.tableData?.table || displayStoreName }}
        </p>
        <button
          class="text-sm text-gray-500 outline rounded py-2 px-2"
          @click="emit('logout')"
          v-if="isShowLogout"
        >
          <i class="fa-solid fa-lock"></i> Lock Screen
        </button>

        <button
        class="text-sm text-gray-500 outline rounded py-2 px-2"
        @click="tokenLogout"
        v-if="isIndexPath"
      >
         Logout
      </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAppStateStore } from "~/store-legacy/appState";
import { useTableStore } from "~/store-legacy/table";
import { useBootstrapStore } from "~/store-legacy/bootstrap";
import { useShopStore } from "~/store-legacy/shop";
import { useSettingStore } from "~/store-legacy/setting";
import {useAuthStore} from '~/store-legacy/auth'

const appStateStore = useAppStateStore();
const tableStore = useTableStore();
const bootStrapStore = useBootstrapStore();
const shopStore = useShopStore();
const settingStore = useSettingStore();
const authStore = useAuthStore();
const $route = useRoute()

const emit = defineEmits(["back", "logout"]);

defineProps({
  title: { type: String },
  isShowBack: { type: Boolean, default: true },
  isShowLogout: { type: Boolean, default: true },
});
const back = () => {
  appStateStore.back()
};
 

const isIndexPath = computed(() => {
  return $route.path === "/pos";
});

const displayStoreName = computed(() => {
  return shopStore.storeName || settingStore.storeName || "";
});

 
const tokenLogout = () => {
  
  if(bootStrapStore?.token?.type == 'employee') {

    const a = 'ต้องการออกจากระบบร้านให้พิมพ์คำว่า  "exit"'
    
    let r = prompt(a)
    if(r?.toLowerCase()?.trim() != 'exit') {
      return
    }
  }

   


  bootStrapStore.loaded = false;
  authStore.logout();
  useRouter().push("/login");

  setTimeout(() => {
      window.location.href = "/login"
  }, 500);

};

</script>



<style scoped>
</style>
